import { render, staticRenderFns } from "./CardUpdatable.vue?vue&type=template&id=cbc3a3ac&"
import script from "./CardUpdatable.vue?vue&type=script&lang=js&"
export * from "./CardUpdatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports